<template>
  <a-modal
    :visible="visible"
    :maskClosable="false"
    :title="$t('attach_share_title')"
    @cancel="handleCancel"
    :footer="null"
    width="500px"
    centered
    v-if="visible"
  >
    <!-- 分享成功弹窗 -->
    <div v-if="shareInfo">
      <div class="success-content" v-if="shareSuccess">
        <Icon type="reset-success" class="success-icon" />
        <div class="success-title">{{ $t('attach_share_success_msg') }}</div>
      </div>
      <div class="share-info">
        <ul>
          <li>
            <label>{{ $t('attach_share_link') }}：</label>
            <span>
              <a :href="Config.shareURL + shareInfo.shareUrl" target="_blank">{{
                Config.shareURL + shareInfo.shareUrl
              }}</a>
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${Config.shareURL + shareInfo.shareUrl}`"
                :id="`attach_copy_code`"
                @click="copyContent(`#attach_copy_code`)"
              />
            </span>
          </li>
          <li>
            <label>{{ $t('attach_share_validity') }}：</label>
            <span>
              {{
                shareInfo.validTime === 36500
                  ? $t('attach_share_validity_forever')
                  : $t('attach_share_validity_days', { days: shareInfo.validTime }) +
                    ',' +
                    $t('attach_share_validity_date', {
                      date: filters.formatDate(shareInfo.validDate),
                    })
              }}
            </span>
          </li>
          <li v-if="shareInfo.passportCode">
            <label>{{ $t('attach_share_access_code') }}：</label>
            <span
              >{{ shareInfo.passportCode }}
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${shareInfo.passportCode}`"
                :id="`attach_copy_code`"
                @click="copyContent(`#attach_copy_code`)"
              />
            </span>
          </li>
        </ul>
        <div class="shared-btn">
          <a-button
            type="red"
            size="large"
            @click="handleDestoryShared({ id: shareInfo.id })"
            :loading="submitLoading"
          >
            {{ $t('com_btn_destroy') }}
          </a-button>

          <a-button type="primary" size="large" class="copy-btn" @click="copyShareInfo">
            {{ $t('com_btn_copy') }}
          </a-button>
        </div>
      </div>
    </div>

    <div v-else>
      <Loading :show="true" v-if="loading" style="margin:20px 0;" />

      <a-form-model
        ref="shareForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        v-else
      >
        <!-- 头部文件信息 -->
        <div class="share-header">
          <div class="file-info">
            <Icon type="file" class="file-icon" />
            <div class="file-detail">
              <div class="file-name">{{ fileData.name }}</div>
              <div class="file-count">{{ $t('attach_share_file_count', { count: 1 }) }}</div>
            </div>
          </div>
        </div>

        <!-- 有效期 -->
        <a-form-model-item :label="$t('attach_share_validity')">
          <a-radio-group v-model="formData.validTime" button-style="solid">
            <a-radio-button :value="1">{{ $t('attach_share_validity_1_day') }}</a-radio-button>
            <a-radio-button :value="7">{{ $t('attach_share_validity_7_days') }}</a-radio-button>
            <a-radio-button :value="30">{{ $t('attach_share_validity_30_days') }}</a-radio-button>
            <a-radio-button :value="36500">{{
              $t('attach_share_validity_forever')
            }}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <!-- 提取码设置 -->
        <!-- <a-form-model-item :label="$t('attach_share_access_code')">
      <a-radio-group v-model="needCode" button-style="solid">
        <a-radio-button :value="true">{{ $t('attach_share_need_code') }}</a-radio-button>
        <a-radio-button :value="false">{{ $t('attach_share_no_code') }}</a-radio-button>
      </a-radio-group>
    </a-form-model-item> -->
      </a-form-model>

      <div class="dialog-footer" v-if="!loading">
        <a-button type="primary" :loading="submitLoading" @click="handleSubmit">
          {{ $t('attach_share_continue') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Clipboard from 'clipboard';
import { generateOrResetShareLink, sharedInfo, destoryShared } from '@/api/attach';
import Config from '@/config';
import { copyContent } from '@/libs/utils';

export default {
  name: 'ShareDialog',
  data() {
    return {
      Config,
      filters: this.$options.filters,
      copyContent,
      visible: false,
      successVisible: false,
      loading: false,
      fileData: {},
      shareInfo: null,
      needCode: false,
      formData: {
        id: null,
        validTime: 7,
      },
      rules: {
        passportCode: [
          {
            required: true,
            len: 4,
            message: this.$t('attach_share_access_code_rule'),
            trigger: 'blur',
          },
        ],
      },
      submitLoading: false,
      shareSuccess: false,
    };
  },
  methods: {
    show(fileData) {
      this.visible = true;
      this.fileData = fileData;
      this.resetForm();

      // 先获取一下是否有分享信息
      this.getShareInfo();
    },
    handleCancel() {
      this.shareInfo = null;
      this.shareSuccess = false;
      this.visible = false;
      this.resetForm();
    },

    resetForm() {
      this.needCode = false;
      this.formData = {
        validTime: 7,
        passportCode: '',
      };
      this.$nextTick(() => {
        this.$refs.shareForm?.clearValidate();
      });
    },

    // 先获取分享信息
    async getShareInfo() {
      this.loading = true;
      sharedInfo({ id: this.fileData.id })
        .then(res => {
          if (res.code === 0) {
            // this.shareInfo = {
            //   id: 113,
            //   available: false,
            //   shareUrl:
            //     '/share/file?rc=351a1fc883924b00abf745f9e524cba11739457942721&tt=1739457942721',
            //   passportCode: '9eazvyr',
            //   validDate: 1740062742721,
            //   validTime: 7,
            // };
            if (res.data && res.data.available) {
              this.shareInfo = res.data;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 提交
    async handleSubmit() {
      try {
        await this.$refs.shareForm.validate();
        this.submitLoading = true;
        this.formData.id = this.fileData.id;
        const res = await generateOrResetShareLink(this.formData);

        if (res.code === 0) {
          this.shareInfo = res.data;

          // 显示分享成功
          this.shareSuccess = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },

    // 复制
    copyShareInfo() {
      if (!this.shareInfo) return;
      const clipboard = new Clipboard('.copy-btn', {
        text: () => {
          let text = '';
          // 链接
          text +=
            this.$t('attach_share_link') +
            ':' +
            `${Config.shareURL + this.shareInfo.shareUrl}` +
            '\n';
          // 有效期
          text +=
            this.$t('attach_share_validity') +
            ':' +
            (this.shareInfo.validTime === 36500
              ? this.$t('attach_share_validity_forever')
              : this.$t('attach_share_validity_days', { days: this.shareInfo.validTime })) +
            ',' +
            this.$t('attach_share_validity_date', {
              date: this.filters.formatDate(this.shareInfo.validDate),
            }) +
            '\n';
          // 提取码
          if (this.shareInfo.passportCode) {
            text += this.$t('attach_share_access_code') + ':' + this.shareInfo.passportCode + '\n';
          }

          return text;
        },
      });

      clipboard.on('success', () => {
        this.$message.success(this.$t('attach_share_copy_success'));
        clipboard.destroy();
      });

      clipboard.on('error', () => {
        this.$message.error(this.$t('attach_share_copy_failed'));
        clipboard.destroy();
      });

      clipboard.onClick({ currentTarget: document.querySelector('.copy-btn') });
    },
    // 销毁
    handleDestoryShared(params = {}) {
      this.$confirm({
        title: this.$t('attach_share_destroy_confirm'),
        content: '',
        okText: this.$t('com_btn_confirm'),
        onOk: () => {
          this.submitLoading = true;
          destoryShared(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('attach_share_destroy_success'));
                this.handleCancel();
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.share-header {
  margin-bottom: 24px;
  .file-info {
    display: flex;
    align-items: center;
    margin-left: 70px;
    .file-icon {
      width: 48px;
      height: 48px;
    }
    .file-detail {
      margin-left: 12px;
      .file-name {
        font-size: 16px;
        font-weight: 500;
        color: #1f1f1f;
        margin-bottom: 4px;
      }
      .file-count {
        font-size: 14px;
        color: #666;
      }
    }
  }
}

.success-content {
  display: flex;
  align-items: center;
  .success-icon {
    width: 48px;
    height: 48px;
    font-size: 48px;
    color: #52c41a;
    margin-right: 16px;
  }
  .success-title {
    font-size: 16px;
    color: #1f1f1f;
  }
}
.share-info {
  width: 100%;
  margin: 12px 0;

  ul {
    li {
      padding: 5px 0;
      font-size: 16px;
    }
  }
}

.dialog-footer {
  text-align: right;
  margin-top: 24px;
}

.shared-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}
</style>
